// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

import { Amplify } from 'aws-amplify'
import { ENV } from './constants'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: ENV.COGNITO_USER_POOL_ID,
      userPoolClientId: ENV.COGNITO_CLIENT_ID,
      loginWith: {
        email: true,
        ...(ENV.HOSTED_UI_ENABLED && ENV.COGNITO_OAUTH_DOMAIN
          ? {
              oauth: {
                domain: ENV.COGNITO_OAUTH_DOMAIN,
                scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
                redirectSignIn: [ENV.COGNITO_REDIRECT_SIGNIN],
                redirectSignOut: [ENV.COGNITO_REDIRECT_SIGNOUT],
                responseType: 'code',
              },
            }
          : {}),
      }
    },
  }
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
